import { render, staticRenderFns } from "./HouseHoldAllowance.vue?vue&type=template&id=c82c8098"
import script from "./HouseHoldAllowance.vue?vue&type=script&lang=js"
export * from "./HouseHoldAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports